export default {
    createaccount_form: "Create Account",
    redemption: "Redemption ",
    redemption_reward: "Redemption ",
    collection: "Collection ",
    _items: "items",
    hello: "Hello,",
    _points: "points",
    term_and_conditions_shop: " Terms & Conditions",
    need_update_info: "You need to update personal information!",
    free_point: "Free point",
    accept: "Accept",
    decline: "Decline",
    _terms_and_conditions: "terms & conditions",
    dont_have_an_account: "Don't have an account? ",
    membership_details: "Membership Details ",
    sign_up_to: "Sign in to ",
    sign_in_to: "Sign in to ",
    choose_sign_up_method: "Choose sign up method ",
    choose_sign_in_method: "Choose sign in method ",
    or: "or",
    forgot: "Forgot",
    password: " password?",
    _password: "Password",
    email: "Email",
    tel: "Tel",
    phone: "Phone number",
    name: "Name",
    surname: "Surname",
    fullname: "FullName",
    name_lastname: "Name - Lastname",
    name_surname: "Name - Surname",
    remember_me: "Remember me",
    confirm_password: "Confirm password",
    reset_your_password: "Reset your password",
    email_recovery_link: "Email recovery link",
    new_password: "New password",
    confirm_new_password: "Confirm new password",
    sign_up: "Next",
    already_have_an_account: "Already have an account? ",
    sign_in: "Next",
    please_enter_OTP: "Please enter OTP",
    submit: "Submit",
    save: "Save",
    verify_email: "Verify email",
    verify_phone: "Verify phone",
    uploadReceipt: "Upload receipt here",
    resend_OTP: "Resend OTP",
    fill_in_the_information_and_receive_special_benefits:
        "Fill in the information and receive special benefits",
    birth_date: "Birth date (dd/mm/yy)",
    accept_terms_conditions: "Accept terms & conditions",
    sign_up_failed: "Sign up Failed",
    sign_in_failed: "Sign in Failed",
    email_password_correct: "Incorrect email or password",
    login_successfully: "Login Successfully",
    login_failed: "Login Failed",
    login: "Login",
    sign_up_now_get: "Sign up now get",
    welcome_to: "Welcome to",
    history_receipt: "Upload receipt",
    redemptions: "Redemptions",
    upload: "Upload",
    points: "Points",
    baht: "BAHT",
    coupon: "Coupon",
    coupons: "Coupons",
    coupon_label: "coupons",
    expire_in: "Expire in",
    _month: "month",
    use_point: "Rewards",
    benefits: "Benefits",
    history: "History",

    collected: "Collected",
    discount_coupon: "Discount coupon",
    desc: "When you buy over 100 bath",
    expiration_date: "Expiration Date",
    recceive_coupon: "Receive coupon ",
    collect_coupon: "Collect coupon ",
    expired: "Expired",
    freeze: "Freeze",
    coupon_code: "Coupon code",
    use_coupon: "Use coupon",
    BAHT: "BAHT",
    percent_sign: "%",
    enter_delivery_address: "Please Enter Delivery Address",
    enter_login_address: "Please Enter Address",
    confirm_address: "Confirm Address",
    address_success: "Update Address Success",

    // coupon: {
    //     collected: "Collected",
    //     discount_coupon: "Discount coupon",
    //     desc: "When you buy over 100 bath",
    //     expiration_date: "Expiration Date",
    //     recceive_coupon: "Receive coupon ",
    //     collect_coupon: "Collect coupon ",
    //     coupon_code: "Coupon code",
    //     use_coupon: "Use coupon",
    // },
    quantity_available: "Quantity ({{number}} items available)",
    have_points_left: "You'll have {{number}} points left",
    select_type: "Select type",
    descriptions: "Descriptions",
    _point: "point",

    MEMBER: "{{text}} MEMBER",
    use_points: "Use points",
    do_not_have_enough_points: "You do not have enough points",
    description: "Description",
    collect_benefit: "Collect benefit",

    done: "Done",
    transaction: "Transaction",
    coupon_title: "Coupon ({{number}} off delivery)",

    used: "Used",

    point: "Point",
    earned: "Earned",
    reward: "Reward",
    benefit: "Benefit",
    confirmation: "Confirmation",
    confirmation_slip: "Confirmation Slip",

    item: "Item",
    ticket: "Ticket",
    date_time: "Date / time",
    type: "Type",
    confirm: "Confirm",
    desConfirm: "Please show this screen or capture this screen and present them to the merchant",

    welcome: "Welcome!",
    become_welcome: "Become ",
    desc_welcome: "member to enjoy exclusive offers!",
    become: "Become a Member",
    qrCode: "QR code",
    qrCode_thai: "ของฉัน",
    my_qr_title: "My QR Code",

    member_id: "Member ID",
    seller_id: "Seller ID",

    request_connect_link: "Request connect LINE account link",
    link_line: "Link LINE account",
    become_member: "Become a member",
    fill_in_your_information: "Fill in your information in order to be a member of ",
    _and_receive: " and receive",
    star_desc: "Collect points to redeem",
    coupon_desc: "Claim coupons",
    benefit_desc: "Free membership benefits",
    draws_desc: "Join lucky draws",
    rules_of_points: "Rules of points",
    _baht_spent: "baht spent",
    _baht: "Baht",

    phone_number: "Phone number",

    date: "Date",
    date_of_birth: "Date of birth",
    link_different: "Link different LINE account",
    request_link: "Request change LINE account link",
    _of: "of",
    _to_level: "to {{rank}} level",
    _level: " level",

    member_ShipTier: "Membership tier",

    member_shipTier_desc: "Unlock exclusive benefits with every new tier!",
    earn_points_in_a_year: "Earn",
    _member: " member",
    _spent: " spent",
    earn: "Earn ",
    upgrade: "to upgrade to",

    point_given: "Point given",

    use_free_point: "Use free point",
    collect_free_points: "Collect free points",

    phone_desc: "We send an OTP code to your mobile",
    email_desc: "We send a verification code to your email",
    enter_it_here: "Enter it here",
    resend_otp: "Resend OTP",
    resend_code: "Resend code",

    goback_home: "Lavish",
    back: "Back",
    select: "Select",
    increase: "Increase",
    decrease: "Decrease",
    add_points_from_shop: "Receive points from the shop: {{points}} points ",
    sub_points_from_shop: "Points deducted by shop: {{points}} points",
    redeem_reward: "Redeem reward",
    redeem_benefit: "Redeem benefit",
    please_sign_up_to_collect_free_point: "Please sign up to collect free point",
    please_sign_up_to_collect_coupon: "Please sign up to collect coupon",
    lang_en: "EN",
    lang_th: "TH",
    en: "English",
    th: "ภาษาไทย",
    no_coupon: "There is no coupon on your account.",
    no_benefit: "There is no benefit on your account.",
    no_point: "There is no reward on your account.",
    no_history: "No usage history",
    confirm_lable_note:
        "Please show this screen or capture this screen and present them to the merchant",
    data_privacy: "Data privacy management",
    consent_marketing_purpose: "Consent for Marketing Purposes",
    we_always_care_about_your_privacy: "We always care about your privacy.",
    how_we_collect:
        "Learn how we collect, use, and disclose your personal data and understand your rights by checking out our",
    research_anaylze:
        "We conduct research and analyze your personal data for your greatest benefit in developing products and services truly fulfilling your needs, as well as for contacting you to offer products, services and benefits exclusively suitable to you.",
    you_agree_let_us:
        "By giving ‘consent’, you agree to let us, Collect and use your personal data for the above-mentioned marketing purposes.",
    right_to_withdraw_this_consent:
        "You have the right to withdraw this consent at any time through Rocket Digital Application, Rocket Digital Call Center at Tel. 02-888-88xx, please see details of the consent withdrawal channels in Privacy Notice. In this regard, the Company will consider proceeding within 7 (seven) days from the date the request is received. In case you exercise your right to withdraw consent after the Company has proceeded to offer you products and external media service provider (i.e. paid media) and/or any other channels, the Company will proceed to stop such offering of products and/or services within 30 (thirty) days from the date the request is received.",
    please_further_read_our_Privacy:
        "Please further read our Privacy Notice carefully to understand how we collect, use and disclose your personal data and your rights posted on our website www.rocketdigital.com",
    if_you_do_not_give_consent:
        "If you do not give consent or withdraw this consent later, you may miss opportunities to receive product, service, and benefit offers suitable to your needs from us.",
    terms_conditons: "Terms & Conditions",
    allow_for: "Allow consent for",
    logout: "Logout",
    pls_answer_questions: "Please answer questions",
    pls_answer_address: "Please answer address",
    use: "Use",
    active: "Active",
    gender: "Gender",
    you_should_fill_dateofbirth_field: "You should answer Date of birth field",
    you_should_fill_email_field: "You should answer email field",
    you_should_fill_gender_field: "You should answer gender field",
    redemption_code: "Redemption Code:",
    additional_information_questionnaire: "Additional information questionnaire",
    please_enter_the_details_above: "Please enter the details above.",
    login_sign_up: "Login / Sign-up",
    to_store: "{{name}}",
    enter_your_phone_number: "Enter your phone number",
    please_proceed_with_LINE: "Please proceed with LINE",
    please_enter_OTP_from_your_SMS: "Please enter OTP from your SMS",
    edit: "Edit",
    send_otp: "Send OTP",
    next: "Next",
    phone_number_placeholder: "Phone Number",
    details_menu: "Details Menu",
    uploadActivity: {
        title: "Upload Activity",
        description:
            "Please upload Activity for collect points You will receive points within 24 hrs.",
        selectTypeLabel: "Activity Type",
        uploadLabel: "+ Click here upload activity",
        viewExampleBtn: "View Example Workout Image",
        sendActivityBtn: "Send Activity",
        selectActivityPlaceholder: "Please select activity type",
        example: {
            title: "View an example image",
            description: "Please take photo get point",
        },
        success: {
            title: "Upload Activity Success!",
            description: "You will receive points within 24 hrs.",
        },
        error: {
            selectActivity: "Please select activity type",
            emptyError: "Please upload activity image",
        },
    },
    upload_receipt: {
        title: "Upload score",
        upload_text: " Upload ",
        receipt: "Evidence",
        view_example: "View Example Receipt",
        view_receipt_example: "Receipt example",
        example: "Example Receipt",
        empty_error: "Please Upload Image",
        success: "Upload Success",
        to_seller: "Recommended Salesperson",
        seller_title: "Recommended Salesperson",
        select_img: "Select Image",
        scan_img: "Scan PC QR",
        send_receipt: "Send Receipt",
        seller_id: "seller id",
        success_with_text: "Upload {{text}} Success",
        upload_failed: "Upload Receipt Failed",
        success_notice: "Your points will be received within {{days}} days.",
    },
    note: "note",
    card: {
        giftCard: "Gift Card",
        title: "Member Cards",
        add_gift_card: "Add Gift Card",
        input_card_num: "gift card",
        input_card_ser: "Serial number",
        place_card_num: "Enter card number",
        place_card_ser: "Enter serial number",
        add_card: "Add Card",
        link_card: "Link Card",
        phy_card_num: "Physical member card",
        phy_card_ser: "Serial number",
        select_member: "Select member type",
        unlink_role:
            "Once you have unlinked your physical card, it will no longer be usable. Instead, your existing online member card will be used.",
        unlink_title: "Do you want to unlink physical card?",
        add_money: "Add money",
        transaction_history: "Transaction history",
        setting_card: "Setting Card",
        link_physical_card: "Link Physical Card",
        online_member_card: "Online Member Card",
        top_up: "Payment & Store top-up",
        select_channel_payment: "Select Channel Payment",
        online_payment: "Online Payment",
        store_payment: "Store Payment",
        enter_amount: "Enter amount",
        thb: "THB",
        used: "Used",
        time: "Time",
    },
    mem_type: {
        create_title: "Create Student Member",
        verify_title: "Upload verification",
        success: "create succress",
        regis_btn: "Apply now",
        bene_for: "Benefit for ",
        bene: "Benefit",
        for: "For",
        employee: "Employee",
        upload_suscess: "Upload verification success",
        please_wait: "Please wait for admin approval",
    },
    top_charoen_terms_title: "เงื่อนไขการร่วมรายการ",
    please_confirm_your_phone_number: "Please confirm your phone number.",
    cancel: "Cancel",
    address: "Address",
    conditions: "Conditions",
    redeem: "Redeem",
    view: "View",
    setting: "Setting",
    myprofile: "My Profile",
    claimcoupon: "Claim Coupon",
    couponcode: "Coupon Code",
    rewardCode: "Reward Code",
    benefitCode: "Benefit Code",
    member_type: {
        pre_title: "Select Member type",
    },
    close: "Close",
    pending: "Pending",
    approve: "Apprived",
    reject: "Rejected",
    history_redeem: {
        title: "History Redeem",
        tab_point: "Points",
        tab_redemp: "Redemptions",
        tab_upload: "Upload",
        gain_point: "Gain point",
        use_point: "Use Point",
        gain: "Gain",
        use: "Use",
        upload: "Upload",
        COUPON: "Coupon",
        REWARD: "Reward",
        BENEFIT: "Benefit",
        ACTIVE: "Redeemed",
        PENDING: "Pending",
        undefined: "Pending",
        RESOLVED: "Used",
        REDEEMED: "Redeemed",
        RECEIVED: "Received",
        REDEEMED_next: "Use",
        RECEIVED_next: "Redeem",
        RESOLVED_next: "Used",
        PENDING_next: "Use",
        undefined_next: "Use",
        expired: "Expired",
        points: "Points",
        LUCKYDRAW: "Lucky draw",
        MISSION: "Mission",
        redeem_date: "Redeem Date",
        exp_date: "Expire Date",
        useDate: "Use Date",
        REPLACED: "Adjust",
        reverse_point: "Reverse point",
        cancel_receipt: "Cancel",
        remark: "Remark",
    },
    invitefriendtoget: "Please copy the code or share the QR code to you friend",
    invitemembertoget: "Please copy the code or share the QR code to you friend",
    pleasecopyinvitefriend: "Point awarded on friend's first purchase",
    pleasecopyinvitemember: "Point awarded on friend's first purchase",
    invitefriend: {
        friend_sign_title: "Copy the link or share the QR code",
        friend_sign_desc: "to your friend to earn points when they sign up",
        friend_collect_title: "Copy the link or share the QR code",
        friend_collect_desc: "to your friend to earn points when they make their first purchase",
        seller_sign_title: "Copy the link or share the QR code",
        seller_sign_desc: "to your friend to earn points when they sign up",
        seller_collect_title: "Copy the link or share the QR code",
        seller_collect_desc: "to your friend to earn points when they make their first purchase",
    },
    copy: "Copy",
    sharelink: "Share link to your friends",
    sharelinkMember: "Share link to your members",
    pretype: {
        email: "Email",
        gender: "Gender",
        dateOfBirth: "Birthday",
        address: "Address",
        id_card: "National ID",
        companyName: "Company Name",
        studentID: "Student ID",
        staffID: "Staff ID",
        channelStore: "Store",
        channelId: "Channel ID",
        storeId: "Store ID",
        staffArea: "Staff Area",
    },
    province: "Province",
    county: "District",
    district: "Sub-district",
    zipcode: "Zip Code",
    createaccount: "Create Account",
    pleaseconfirm: "Please confirm to redeem",
    detail: "Detail",
    campaignperiod: "Campaign period",
    participate: "Participate",
    luckydraw: "Lucky Draw",
    desLuckydraw:
        "You have successfully participated in the lucky draw. Please wait for announcement.",
    for_new_member_only: "For new member only",
    day: "Day",
    month: "Month",
    year: "Year",
    update_email_success: "Email has been updated successfully!",
    congratulation: "Congratulation !",
    youget: "You Get",
    survey_submit_success_no_point:
        "Thank you for completing the survey. Your responses have been recorded successfully.",
    claimreward: "Claim Reward",
    MALE: "Male",
    FEMALE: "Female",
    NOT_SPECIFIED: "Not specified",
    leaderboard_disabled: "Leaderboard has been closed.",
    waiting_rank: "Calculating the ranking...",
    cardId: "Card ID",
    dataNotFound: "Data not found.",
    verify: "Verify",
    get_otp: "Get OTP",
    resend: "Resend",
    all_fields_are_required: "Please fill out the information completely.",
    staffArea: "Staff Area",
    paymentProcessing: "Redirecting to top-up page",
    selectmembergroup: "Please select Member Group",
    line_login: "Login with LINE*",
    line_login_subtitle: "Please login with LINE Account*",
    giftcard: "Gift Card",
    usage: "Usage",
    transactionhistory: "Transaction History",
    settingcard: "Setting Card",
    removecard: "Remove Card",
    usageamount: "Usage Amount",
    usegiftcard: "Use Gift Card",
    pleaseselectamounttouse: "Please Select Amount To Use",
    thb: "THB",
    enterordernumberhere: "Enter order number here",
    claimorderid: "Claim Order Number",
    nodatafound: "No orders from other platforms yet.",
    saleAmount: "Sale Amount",
    claim: "Claim",
    areyousure: "Are you sure you want to claim points for this order?",
    onceclaimed: "Once claimed, you will not be able to refund the product.",
    campaign: {
        details: "Details",
        joinnow: "Join now !",
        leaderboard: "Leaderboard",
        stats: "Stats",
        ranking: "Ranking",
        timeupload: "Time upload",
        totalpointscollected: "Total points collected",
        total: "Total",
        pending: "Pending",
        approve: "Approved",
        reject: "Rejected",
        nodata: "No Data",
        uploadactivity: "Upload Activity",
        uploadactivitypoint: "Upload Activity to collect points",
    },
    // claimfalse: "Your order status can't claim point",
    claimfalse:
        "If the status is ‘Delivered' or 'Completed’ but you cannot claim points yet, please try again the next day.",
    pleasEnterOrder: "Please enter order number",
    orderNotFound: "Your order not found",
    claimSuccess: "You have successfully claimed the points",
    youDelivery: "Your reward will be delivered to the address below.",
    exp: "Valid",
    pleaseSelect: "Please Select",
    display_profile_pointLessZero: "Tier will be updated soon",
};
